/* eslint-disable camelcase */
import common_en from './en/common.json';
import common_ch from './ch/common.json';
import common_gr from './gr/common.json';
import common_pr from './pr/common.json';
import common_sl from './sl/common.json';
import common_sp_mex from './sp-mex/common.json';
import common_sp_sp from './sp-sp/common.json';

import errors_en from './en/errors.json';
import errors_ch from './ch/errors.json';
import errors_gr from './gr/errors.json';
import errors_pr from './pr/errors.json';
import errors_sl from './sl/errors.json';
import errors_sp_mex from './sp-mex/errors.json';
import errors_sp_sp from './sp-sp/errors.json';

const resources =  {
  en: {
    common: common_en,
    errors: errors_en,
  },
  ch: {
    common: common_ch,
    errors: errors_ch,
  },
  gr: {
    common: common_gr,
    errors: errors_gr,
  },
  pr: {
    common: common_pr,
    errors: errors_pr,
  },
  sl: {
    common: common_sl,
    errors: errors_sl,
  },
  sp_mex: {
    common: common_sp_mex,
    errors: errors_sp_mex,
  },
  sp_sp: {
    common: common_sp_sp,
    errors: errors_sp_sp,
  }
};

export {
  resources
}
